class TipoEmolumento {
  constructor() {
    
  }
}

export default TipoEmolumento
